var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElBadge',{staticClass:"new-badge",attrs:{"value":_vm.$t('NEW')}})
}
var staticRenderFns = []

export { render, staticRenderFns }